import { render, staticRenderFns } from "./estatisticas-incidentes.vue?vue&type=template&id=04883b0e&scoped=true"
import script from "./estatisticas-incidentes.vue?vue&type=script&lang=js"
export * from "./estatisticas-incidentes.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-incidentes.vue?vue&type=style&index=0&id=04883b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04883b0e",
  null
  
)

export default component.exports